<app-sp-header></app-sp-header>
<app-sp-tabbar></app-sp-tabbar>
<div style="min-height: calc(100vh - 144px)">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>